(() => {
  'use strict';

  const animationSelector = '[data-er-animate]';
  const visibleClass = 'is-visible';

  function revealElement(element) {
    if (!element || element.classList.contains(visibleClass)) {
      return;
    }

    const delayValue = parseInt(element.dataset.erDelay || '0', 10);
    const delay = Number.isFinite(delayValue) ? Math.max(0, delayValue) : 0;

    window.setTimeout(() => {
      element.classList.add(visibleClass);
    }, delay);
  }

  function revealAll(elements) {
    elements.forEach((element) => {
      revealElement(element);
    });
  }

  function initializeAnimations(root = document) {
    const elements = Array.from(
      root.querySelectorAll(animationSelector)
    );

    if (!elements.length) {
      return;
    }

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (reducedMotion || !('IntersectionObserver' in window)) {
      revealAll(elements);
      return;
    }

    const observer = new IntersectionObserver(
      (entries, instance) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          revealElement(entry.target);
          instance.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -10% 0px',
        threshold: 0.12
      }
    );

    elements.forEach((element) => {
      observer.observe(element);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeAnimations();
    });
  } else {
    initializeAnimations();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAnimations(event.target);
  });

  document.addEventListener('shopify:section:reorder', () => {
    initializeAnimations();
  });
})();